<app-background-card
  [title]="headerKey() | transloco"
  titleTestId="company-list-header"
  testId="company-list-card"
  [actionLabel]="showCreateAction() ? ('company.setup' | transloco) : undefined"
  actionTestId="setup-company-button"
  (actionClick)="create.emit()"
>
  @if (loading()) {
    <app-loading />
  } @else {
    @if (hasOffices()) {
      <ng-container>
        <p-table
          #dt
          [value]="offices()"
          [rows]="10"
          [paginator]="true"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
          [responsiveLayout]="'scroll'"
          [globalFilterFields]="globalFilterFields()"
          [loading]="loading()"
          data-testid="company-list-table"
        >
          <ng-template #caption>
            <div class="flex justify-end">
              <app-global-search (searchValue)="dt.filterGlobal($event, 'contains')" />
            </div>
          </ng-template>

          <ng-template #header>
            <tr>
              @for (col of columns(); track col.field) {
                <th
                  pSortableColumn="{{ col.field }}"
                  [attr.data-testid]="col.testId + '-header'"
                  [style.width]="col.width ?? 'auto'"
                  scope="col"
                >
                  {{ col.headerKey | transloco }}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
              @if (showEdit()) {
                <th
                  style="width: 5rem"
                  class="text-center!"
                  data-testid="company-list-actions-header"
                  scope="col"
                ></th>
              }
            </tr>
          </ng-template>

          <ng-template #body let-office>
            <tr data-testid="company-list-row">
              @for (col of columns(); track col.field) {
                <td [attr.data-testid]="col.testId + '-cell'">
                  @switch (col.field) {
                    @case ('countryCode') {
                      <span class="fi fi-{{ office.countryCode | lowercase }} text-xl!"></span>
                      {{ countryService.getCountryNameByCode(office.countryCode) }}
                    }
                    @case ('projects') {
                      @for (project of office.projects; track project.id) {
                        <ng-container>
                          {{ project.name }}
                          @if (!last) {
                            <span>, </span>
                          }
                        </ng-container>
                      }
                    }
                    @default {
                      {{ office[col.field] }}
                    }
                  }
                </td>
              }
              @if (showEdit()) {
                <td class="flex gap-2" data-testid="company-list-row-actions">
                  <p-button
                    icon="pi pi-pencil"
                    severity="secondary"
                    (onClick)="edit.emit(office.companyId)"
                    data-testid="edit-company-button"
                    text
                  ></p-button>
                </td>
              }
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr>
              <td [attr.colspan]="showEdit() ? columns().length + 1 : columns().length">
                <app-no-data />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>
    } @else {
      <ng-content select="[emptyState]">
        <app-no-data icon="pi pi-building" label="company.emptyListText">
          @if (showCreate()) {
            <p-button
              label="{{ 'company.setup' | transloco }}"
              styleClass="px-8!"
              (onClick)="create.emit()"
              data-testid="setup-company-empty-button"
            ></p-button>
          }
        </app-no-data>
      </ng-content>
    }
  }
</app-background-card>
